import * as moment from "moment";
import * as React from "react";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import { StyleClassAuto } from "source/app/presentation/Shared/Styles/Auto/StyleClassAuto";
import IconWithText from "source/app/services/Shared/IconWithText/IconWithText";
import { ShowDateTimeLocalInput } from "./Helpers/ShowDateTimeLocalInput";
import { ICalendarEventEditorState } from "./ICalendarEventEditorState";
import Nameof from "source/app/services/NameOf";
import { GetTodaysDate } from "motw_core/Services/TimeServices";

export function FirstEventDate({
    state,
    setState,
}: {
    state: ICalendarEventEditorState;
    setState: React.Dispatch<React.SetStateAction<ICalendarEventEditorState>>;
}) {
    if (!state.calendarEvent.isRepeating) {
        return null;
    }

    const currentFirstRecurrenceMoment = moment(
        state.calendarEvent.firstRecurrenceDate,
        "YYYY-MM-DDTHH:mm:ss.SSSZ",
        true
    );

    const todayMoment = GetTodaysDate();

    const clonedMomentWithToday = moment(todayMoment).set({
        hour: currentFirstRecurrenceMoment.hour(),
        minute: currentFirstRecurrenceMoment.minute(),
    });

    return (
        <div
            className={StyleClassAuto({
                margin: `0px 0px 15px 0px`,
                opacity: 0.5,
            })}
        >
            <ShowDateTimeLocalInput
                {...{
                    state,
                    setState,
                    label: `firstRecurrenceDate`,
                    isReadOnly: false,
                }}
            />
            <IconWithText
                id="setDateToTodayIcon"
                iconSuffix={EGlyphicon.download}
                whenClicked={() => {
                    setState({
                        ...state,
                        calendarEvent: {
                            ...state.calendarEvent,
                            firstRecurrenceDate: clonedMomentWithToday.format(
                                "YYYY-MM-DDTHH:mm:ssZ"
                            ),
                        },
                    });
                }}
                withClass={StyleClassAuto({
                    opacity: 0.7,
                    marginTop: `5px`
                })}
                displayAsBlock={true}
            >
                Set to Today
            </IconWithText>
        </div>
    );
}
